@let canSearchForListings = canSearchForListings$ | async;

<div class="mobile-bottombar" [class.mobile-bottombar--full]="canSearchForListings">

    <rpc-button class="mobile-bottombar-btn" [iconName]="'home'" [color]="activeItem === 'landing' ? 'accent': null"
        (clicked)="onHomeClicked()">
    </rpc-button>

    @if (canSearchForListings) {
    <rpc-button class="mobile-bottombar-btn" [iconName]="'search'" [color]="activeItem === 'search' ? 'accent': null"
        (clicked)="onSearchClicked()">
    </rpc-button>
    }

    <rpc-button class="mobile-bottombar-btn" [iconName]="'folder'" [color]="activeItem === 'portfolio' ? 'accent': null"
        (clicked)="onPortfolioClicked()">
    </rpc-button>

    <rpc-button class="mobile-bottombar-btn" [iconName]="'appointment'"
        [color]="activeItem === 'appointments' ? 'accent': null" (clicked)="onAppointmentsClicked()">
    </rpc-button>

    <rpc-button class="mobile-bottombar-btn" [iconName]="'bell'"
        [color]="activeItem === 'notifications' ? 'accent': null"
        [badge]="{badgeCountAlert: unviewedNotificationTotalCount$ | async, badgeCountAlertLimit: badgeCountAlertLimit}"
        (clicked)="onNotificationBellClicked()">
    </rpc-button>

</div>